import Vue from 'vue'
import VueRouter from 'vue-router'
import MainPage from '@/pages/MainPage.vue'
import RegisterPage from '@/pages/RegisterPage.vue'
import RegisterSuccessPage from '@/pages/RegisterSuccessPage.vue'
import PersonalPage from '@/pages/PersonalPage.vue'
import UserPage from '@/pages/UserPage.vue'
import ApprovePage from '@/pages/ApprovePage.vue'
import NotFoundPage from '@/pages/NotFoundPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'main',
    component: MainPage
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterPage
  },
  {
    path: '/register/success',
    name: 'registerSuccess',
    component: RegisterSuccessPage
  },
  {
    path: '/personal',
    name: 'personal',
    component: PersonalPage
  },
  {
    path: '/approve/:hash',
    name: 'approve',
    component: ApprovePage
  },
  {
    path: '/personal/user',
    name: 'user',
    component: UserPage
  },
  {
    path: '/*',
    name: 'notFound',
    component: NotFoundPage
  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
